import { isEmpty } from 'lodash';

import { POPUPS } from '@common/constants/popups';
import { browserHistory } from '@common/helpers/browserHistory';
import { getSelectionsContextValue } from '@common/contexts/selections';
import { BetslipCommunicator, BetslipEventsEnum } from '@betslip/communicator';

import { copyEvents } from './addBetToExisting';
import { openDeferModal } from '../openDeferPopup';

const addBetToExisting = async (ticket, boostedOddsGameIds, setSelections) => {
  const betEvents = await copyEvents(ticket, boostedOddsGameIds);

  setSelections((newSelections) => ({
    ...newSelections,
    events: betEvents,
  }));

  if (ticket?.dataFromSwarm?.type_id)
    BetslipCommunicator.send(BetslipEventsEnum.ChangeBetType, {
      betType: ticket.dataFromSwarm.type_id,
    });
};

export const copyToBetslip = async (ticket) => {
  const [{ events, boostedOddsGameIds }, setSelections] = getSelectionsContextValue();

  if (!isEmpty(events)) {
    const isConfirmed = await openDeferModal(POPUPS.CONFIRMATION_MODAL, {
      message: 'Would you like to clear betslip, or add on existing selections',
    });

    if (isConfirmed) {
      addBetToExisting(ticket, boostedOddsGameIds, setSelections);
      browserHistory.push('/betting/prematch');
    }
  } else {
    addBetToExisting(ticket, boostedOddsGameIds, setSelections);
    browserHistory.push('/betting/prematch');
  }
};
